export default __webpack_public_path__ + "e91f8913236efe341fc7c16abfe57346.svg";